jQuery(function($){
    if ($('.product-card').length == 0) {
        return;
    }

    initProductCardSlider();

    // Store selected options
    let selectedUitstraling = $('.switcher__option[data-switcher="uitstraling"].active').data('target') || null;
    let selectedDeurgrootte = $('.switcher__option[data-switcher="deurgrootte"].active').data('target') || null;
    let selectedZijlichten = $('.switcher__option[data-switcher="zijlichten"].active').data('target') || null;

    updateProductUrls();

    $(document).on('click', '.producten__switcher .switcher__option', function () {
        const $clicked = $(this);
        const switcherType = $clicked.data('switcher');
        const target = $clicked.data('target');
    
        // Temporarily update values
        let newUitstraling = switcherType === 'uitstraling' ? target : selectedUitstraling;
        let newDeurgrootte = switcherType === 'deurgrootte' ? target : selectedDeurgrootte;
        let newZijlichten = switcherType === 'zijlichten' ? target : selectedZijlichten;


        // Loop through each product card
        $('.product-card').each(function () {
            const $product = $(this);

            const $matchingSlides = $product.find('.product__slide.flexible').filter(function () {
                const $slide = $(this);
                const matchU = !newUitstraling || $slide.hasClass(newUitstraling);
                const matchG = !newDeurgrootte || $slide.hasClass(newDeurgrootte);
                const matchZ = !newZijlichten || $slide.hasClass(newZijlichten);
                return matchU && matchG && matchZ;
            });

            if ($matchingSlides.length === 0) {
                return; // Skip if no matching slide
            }

            // Only update global values if a match is found
            if (switcherType === 'uitstraling') {
                selectedUitstraling = target;
                $product.find('.product__uitstraling').removeClass('active');
                $product.find('.product__uitstraling[data-value="' + target + '"]').addClass('active');
            } else if (switcherType === 'deurgrootte') {
                selectedDeurgrootte = target;
            } else if (switcherType === 'zijlichten') {
                selectedZijlichten = target;
            }

            // Update slide visibility
            $product.find('.product__slide.flexible').each(function () {
                const $slide = $(this);
                const matchU = !selectedUitstraling || $slide.hasClass(selectedUitstraling);
                const matchG = !selectedDeurgrootte || $slide.hasClass(selectedDeurgrootte);
                const matchZ = !selectedZijlichten || $slide.hasClass(selectedZijlichten);
                $slide.toggleClass('active', matchU && matchG && matchZ);
            });

            const swiperContainer = $product.find('.swiper-container')[0];
            if (swiperContainer && swiperContainer.swiper) {
                swiperContainer.swiper.slideToLoop(0);
            }

            const params = new URLSearchParams();
            if (selectedUitstraling) params.set('uitstraling', selectedUitstraling);
            if (selectedDeurgrootte) params.set('deurgrootte', selectedDeurgrootte);
            if (selectedZijlichten) params.set('zijlichten', selectedZijlichten);

            $product.find('.product__url').each(function () {
                const $link = $(this);
                const href = $link.attr('href').split('?')[0]; // Clean existing parameters
                $link.attr('href', href + '?' + params.toString());
            });
        });
    });

    function updateProductUrls() {
        $('.product-card').each(function () {
            const $product = $(this);
    
            const params = new URLSearchParams();
            if (selectedUitstraling) params.set('uitstraling', selectedUitstraling);
            if (selectedDeurgrootte) params.set('deurgrootte', selectedDeurgrootte);
            if (selectedZijlichten) params.set('zijlichten', selectedZijlichten);
    
            $product.find('.product__url').each(function () {
                const $link = $(this);
                const href = $link.attr('href').split('?')[0];
                $link.attr('href', href + '?' + params.toString());
            });
        });
    }

    $(document).on('click', '.product__uitstraling', function(e){
        e.preventDefault();
    
        const value = $(this).data('value');
        const $product = $(this).closest('.product-card');
    
    
        $product.find('.product__uitstraling').removeClass('active');
        $(this).addClass('active');
    
        $product.find('.product__slide.flexible').each(function () {
            const $slide = $(this);
            const matchU = $slide.hasClass(value);
            const matchG = $slide.hasClass(selectedDeurgrootte);
            $slide.toggleClass('active', matchU && matchG);
        });
    
        const swiperContainer = $product.find('.swiper-container')[0];
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.slideToLoop(0);
        }
    });
});

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export function initProductCardSlider(){
    (function($) {
        $('.product__slider').each(function(index, element) {
            if ($(element).find('.swiper-container').length === 0) {
                return;
            }

            // Initialize Swiper
            const slider = new Swiper($(element).find('.swiper-container')[0], {
                loop: true,
                spaceBetween: 0,
                slidesPerGroup: 1,
                slidesPerView: 1,
                lazy: true, 
                speed: 200, 
                navigation: {
                  nextEl: $(element).find('.slider__next').toArray(), 
                  prevEl: $(element).find('.slider__prev').toArray(), 
                },
            });
        });
    })(jQuery);
}
